<template>
    <div class="n2-center-container">
        <div><app-content name="web.trips.main"></app-content></div>
        <div class="n3-form-header"></div>
        <div class="n2-row">
            <div class="travel-options col-md-8 n2-padding">
                <div class="n2-title">{{ $t('pages.trips.outward_trips') }}</div>
                <trip-search v-bind:loading="outward_loading" v-bind:date="query.outward_date" v-bind:time_zone="'Europe/Oslo'"
                    v-bind:legs="outward_trips" v-on:previous-day-selected="outwardChangeDay(-1)"
                    v-on:next-day-selected="outwardChangeDay(1)"
                    v-on:leg-selected="selectLeg($event, 'outward')"></trip-search>

                <hr />
                <template v-if="query.roundtrip.toString() == 'true'">
                    <div class="n2-title">{{ $t('pages.trips.backward_trips') }}</div>
                    <trip-search v-bind:loading="backward_loading" v-bind:date="query.backward_date" v-bind:time_zone="'Europe/Oslo'"
                        v-bind:legs="backward_trips" v-on:previous-day-selected="backwardChangeDay(-1)"
                        v-on:next-day-selected="backwardChangeDay(1)"
                        v-on:leg-selected="selectLeg($event, 'backward')"></trip-search>
                </template>
            </div>
            <div class="col-md-4 n2-padding">
                <shopping-cart></shopping-cart>
            </div>
        </div>
        <ul class="n2-errors n2-margin-top">
            <li v-if="validate('outward_trip')">
                {{ $t('pages.trips.error_outward_trip') }}
            </li>
            <li v-if="validate('backward_trip')">
                {{ $t('pages.trips.error_backward_trip') }}
            </li>
            <li v-if="validate('trips_relation')">
                {{ $t('pages.trips.error_trips_relation') }}
            </li>
        </ul>
        <div class="n2-display-flex n2-justify-content-space-between n2-padding">
            <button class="n2-button-1" v-on:click="previousStep">{{ $t('pages.trips.previous_step') }}</button>
            <button class="n2-button-1" v-on:click="nextStep">{{ $t('pages.trips.next_step') }}</button>
        </div>
        <div id="n1-time-passed-modal" class="w3-modal">
            <div class="w3-modal-content w3-card-4" style="max-width:800px;position:relative;">
                <div class="n2-padding">
                    <div>
                        <h4 class="n2-text-center">{{ $t('pages.trips.time_passed_title') }}</h4>
                        <p class="n2-text-center">{{ $t('pages.trips.time_passed_content') }}</p>
                    </div>
                    <div class="n2-text-center n2-margin">
                        <button v-on:click="closeModal()" class="n2-button-1">OK</button>
                    </div>
                </div>
            </div>
        </div>
        <div id="n1-general-error-modal" class="w3-modal">
            <div class="w3-modal-content w3-card-4" style="max-width:800px;position:relative;">
                <div class="n2-padding">
                    <div>
                        <h4 class="n2-text-center">{{ $t('pages.trips.general_error_title') }}</h4>
                        <p class="n2-text-center">{{ $t('pages.trips.general_error_content') }}</p>
                    </div>
                    <div class="n2-text-center n2-margin">
                        <button v-on:click="closeModal()" class="n2-button-1">OK</button>
                        <button style="margin-left: 20px;" v-on:click="goHome()" class="n2-button-1">{{ $t('pages.trips.go_home') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import helper from '../helpers/localization-helper'
import AppContent from '../components/shared/content.vue';
import { ShoppingCartService, TripService } from '../services'
import ShoppingCart from '../components/app/shopping-cart.vue';
import TripSearch from '../components/app/trip-search.vue';

export default {
    name: 'PageTrips',
    components: {
        ShoppingCart, TripSearch, AppContent
    },
    data: function () {
        return {
            model_errors: {},
            outward_loading: true,
            backward_loading: true,
            outward_trips: [],
            backward_trips: [],
            outward_trip: null,
            backward_trip: null,
            query: { outward_date: '', backward_date: '', roundtrip: 'false' },
            invalid_fields: []
        }
    },
    computed: {
        ...mapGetters('globalization', [
            'app_locale',
            'locale'
        ]),
        shopping_cart: function () {
            // `this` points to the vm instance
            return this.$store.state.shopping_cart_store.shopping_cart
        }
    },
    created: function () {
        this.tripService = new TripService();
        this.shoppingCartService = new ShoppingCartService();
    },
    mounted: async function () {
        var addResult = await this.shoppingCartService.create({
        });
        this.$store.commit('shopping_cart_store/update', addResult.data)

        Object.assign(this.query, this.$route.query)
        this.searchTrips();


        //var stopResult = await this.stopService.search({ page_size: 200 });
        //this.origins = stopResult.data;
    },
    methods: {
        closeModal: function () {
            var x = document.getElementsByClassName("w3-modal");
            var i;
            for (i = 0; i < x.length; i++) {
                x[i].style.display = "none";
            }
        },
        getSharedRequest: function () {
            return {
                products: JSON.parse(this.query.products),
                roundtrip: this.query.roundtrip,
                locale: this.locale,
                //discount_code:
                //customer_id:null,
            }
        },
        searchOutwardTrips: function () {
            let request = this.getSharedRequest();
            let outwardRequest = Object.assign({
                origin: 'stop_id:' + this.query.origin_id,
                destination: 'stop_id:' + this.query.destination_id,
                date: this.query.outward_date
            }, request);
            this.outward_loading = true;
            this.tripService.search(outwardRequest).then(a => {
                this.outward_trips = a.data;
            }).finally(() => { this.outward_loading = false; });
        },
        searchBackwardTrips: function () {
            let request = this.getSharedRequest(this.query);
            let backwardRequest = Object.assign({
                origin: 'stop_id:' + this.query.destination_id,
                destination: 'stop_id:' + this.query.origin_id,
                date: this.query.backward_date
            }, request);
            this.backward_loading = true;
            this.tripService.search(backwardRequest).then(b => {
                this.backward_trips = b.data;
            }).finally(() => { this.backward_loading = false; });
        },
        searchTrips: function () {
            this.searchOutwardTrips();
            if (this.query.roundtrip.toString() == 'true') {
                this.searchBackwardTrips();
            }
        },

        outwardChangeDay: function (day) {
            let d = helper.addDays(this.query.outward_date, day);
            this.query.outward_date = d.split('T')[0];
            this.searchOutwardTrips();
        },
        backwardChangeDay: function (day) {
            let d = helper.addDays(this.query.backward_date, day);
            this.query.backward_date = d.split('T')[0];
            this.searchBackwardTrips();
        },
        selectLeg: async function (leg, direction) {

            if (direction == 'outward') {
                this.outward_trip = leg;
            }
            else {
                this.backward_trip = leg;
            }
            let legs = [];
            if (this.outward_trip) {
                legs.push(this.outward_trip);
            }
            if (this.backward_trip) {
                legs.push(this.backward_trip);
            }
            try {
                var cartResult = await this.shoppingCartService.create({
                    locale: this.locale,
                    roundtrip: this.query.roundtrip,
                    payment_type: 'purchase',
                    //customer_id: null,
                    //discount_code: "string",
                    legs: legs
                });
                this.$store.commit('shopping_cart_store/update', cartResult.data)

            } catch (err) {
                if (direction == 'outward') {
                    this.outward_trip = null;
                }
                else {
                    this.backward_trip = null;
                }
                console.log(err)
                if (err.data.error_code == 'general_error') {
                    document.getElementById('n1-general-error-modal').style.display = 'block';
                    this.$store.commit('shopping_cart_store/update', null)
                }
                else {
                    document.getElementById('n1-time-passed-modal').style.display = 'block';
                }
            }
        },
        previousStep: function () {
            this.$router.push({ path: `/${this.app_locale}`, query: this.query })
        },
        validate: function (name) {
            return this.invalid_fields.includes(name);
        },
        goHome:function(){
            this.$router.push({ path: `/${this.app_locale}`, query: {} });
        },
        nextStep: function () {
            this.$store.commit('current_session/set_checkout_token', '');
            this.invalid_fields = [];
            if (!this.outward_trip) {
                this.invalid_fields.push('outward_trip');
            }
            if (this.query.roundtrip == 'true' || this.query.roundtrip === true) {
                if (!this.backward_trip) {
                    this.invalid_fields.push('backward_trip');
                }
                else if (this.outward_trip) {
                    let outwardArriveAt = new Date(this.outward_trip.steps[this.outward_trip.steps.length - 1].transit.arrive_at);
                    let backwardDepartAt = new Date(this.backward_trip.steps[0].transit.depart_at);
                    if (outwardArriveAt > backwardDepartAt) {
                        this.invalid_fields.push('trips_relation');
                    }
                }
            }


            if (this.invalid_fields.length == 0) {
                this.$router.push({ path: `/${this.app_locale}/checkout` })
            }
        }
    }
}
</script>
